<template>
  <v-card-text class="py-3">
    <div v-if="sleepTemp" class="d-flex align-center justify-center mb-5">
      <div>修正前：</div>
      <v-chip color="sleep" class="mr-2" variant="outlined" size="x-small">睡眠</v-chip>
      <div class="">
        {{ formatTime(sleepTemp.from) }} 〜 {{ formatTime(sleepTemp.to) }}
      </div>
    </div>

    <v-menu
      v-model="isFromTimePicker"
      :close-on-content-click="false"
      location="bottom start"
      transition="scale-transition"
      min-width="290px"
      max-width="290px"
    >
      <template v-slot:activator="{ props }">
        <v-text-field
          :model-value="localFrom"
          label="開始"
          prepend-icon="mdi-clock-time-four-outline"
          :rules="[rules.required]"
          readonly
          v-bind="props"
          variant="outlined"
          density="compact"
          color="primary"
        ></v-text-field>
      </template>
      <v-time-picker
        v-if="isFromTimePicker"
        v-model="localFrom"
        format="24hr"
        locale="ja"
        :allowed-minutes="allowedStep"
        @update:model-value="onFromPicked"
        color="primary"
        @keydown.capture.prevent
      ></v-time-picker>
    </v-menu>

    <v-menu
      v-model="isToTimePicker"
      :close-on-content-click="false"
      location="bottom start"
      transition="scale-transition"
      min-width="290px"
      max-width="290px"
    >
      <template v-slot:activator="{ props }">
        <v-text-field
          :model-value="localTo"
          label="終了"
          prepend-icon="mdi-clock-time-four-outline"
          :rules="[rules.required]"
          readonly
          v-bind="props"
          variant="outlined"
          density="compact"
          color="primary"
        ></v-text-field>
      </template>
      <v-time-picker
        v-if="isToTimePicker"
        v-model="localTo"
        format="24hr"
        locale="ja"
        :allowed-minutes="allowedStep"
        @update:model-value="onToPicked"
        color="primary"
        @keydown.capture.prevent
      ></v-time-picker>
    </v-menu>
  </v-card-text>
</template>
<script lang="ts">
import Vue, { PropType, defineComponent } from 'vue';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
dayjs.locale('ja');
import rules from '@/service/ValidRules';
import { SleepResponse } from 'chaild-api/lib';

export default defineComponent({
  name: 'SleepModal',

  emits: ['update:from', 'update:to'],

  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    childId: {
      type: Number,
      default: NaN,
    },
    selectedDate: {
      type: String,
      default: dayjs().format('YYYY-MM-DD'),
    },
    sleepTemp: {
      type: Object as PropType<SleepResponse>,
    },
    from: {
      type: String,
      default: '',
    },
    to: {
      type: String,
      default: '',
    },
  },

  computed: {
    rules() {
      return rules;
    },
    form() {
      return (this.$refs as any).post_milk_form;
    },
  },

  watch: {
    isOpen: {
      handler(val: boolean) {
      },
      deep: true,
    },
    from(newVal) {
      if (newVal) {
        this.localFrom = dayjs(newVal).format('HH:mm');
      } else {
        this.localFrom = '';
      }
    },
    to(newVal) {
      if (newVal) {
        this.localTo = dayjs(newVal).format('HH:mm');
      } else {
        this.localTo = '';
      }
    },
  },

  data: () => ({
    btnLoading: false,
    isFromTimePicker: false,
    isToTimePicker: false,
    localFrom: '',
    localTo: '',
  }),

  methods: {
    allowedStep: (m: any) => m % 5 === 0,
    onFromPicked(newTime: string | null) {
      if (!newTime) return;
      this.localFrom = newTime;
      const [hour, minute] = newTime.split(':');
      const iso = dayjs().hour(Number(hour)).minute(Number(minute)).second(0).millisecond(0).toISOString();
      this.$emit('update:from', iso);
      this.isFromTimePicker = false;
    },
    onToPicked(newTime: string | null) {
      if (!newTime) return;
      this.localTo = newTime;
      const [hour, minute] = newTime.split(':');
      const iso = dayjs().hour(Number(hour)).minute(Number(minute)).second(0).millisecond(0).toISOString();
      this.$emit('update:to', iso);
      this.isToTimePicker = false;
    },
    formatTime(time: string) {
      const nowTime = dayjs(time).format('HH:mm');
      return nowTime;
    },
  },
  mounted() {
    if (this.from) {
      this.localFrom = dayjs(this.from).format('HH:mm');
    }
    if (this.to) {
      this.localTo = dayjs(this.to).format('HH:mm');
    }
  },
});
</script>
<style lang="scss" scoped></style>
